module.exports = __webpack_public_path__ + "static/media/panelova_diskusia.368eed6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/panelova_diskusia.jpg
// module id = 505
// module chunks = 0